import { ProductCard } from "@/types/productCard";
import { getAppEnv, getRuntimeEnv } from "../getBrowserEnv";
import { APP_KEY, CODE_ENV, CURRENT_CODE_ENV, RUNTIME_ENV_TYPE } from "../constant";
import { JumpConfig, JumpTypeEnum } from "../jumpPage";
import getUnpl from "../getUnpl";

const H5_GOOD_DETAIL_URL = {
  [CODE_ENV.DEVELOP]: "https://h5-peppermall.mall.test.sankuai.com/pages/goodDetail/index",
  [CODE_ENV.TEST]: "https://h5-peppermall.mall.test.sankuai.com/pages/goodDetail/index",
  [CODE_ENV.STAGING]: "https://h5.peppermall.meituan.com/pages/goodDetail/index",
  [CODE_ENV.PRODUCTION]: "https://h5.peppermall.meituan.com/pages/goodDetail/index",
}

const GOOD_DETAIL_URL_CONFIG = {
  [JumpTypeEnum.H5]: H5_GOOD_DETAIL_URL[CURRENT_CODE_ENV as CODE_ENV],
  [JumpTypeEnum.MT_WXAPP]: "/pepper/pages/goodDetail/index",
};

export const getGoodDetailPath = () => {
  const runtimeEnv = getRuntimeEnv();
  if (runtimeEnv === RUNTIME_ENV_TYPE.MT_MINI) {
    return GOOD_DETAIL_URL_CONFIG[JumpTypeEnum.MT_WXAPP];
  } else {
    return GOOD_DETAIL_URL_CONFIG[JumpTypeEnum.H5];
  }
};

export const getJumpTypeEnum = () => {
  const runtimeEnv = getRuntimeEnv();
  switch (runtimeEnv) {
    case RUNTIME_ENV_TYPE.BROWSER:
      return JumpTypeEnum.H5;
    case RUNTIME_ENV_TYPE.MT_APP:
      return JumpTypeEnum.MT_APP;
    case RUNTIME_ENV_TYPE.MT_MINI:
      return JumpTypeEnum.MT_WXAPP;
    default:
      return JumpTypeEnum.H5;
  }
};

/**
 * 获取商品跳转配置
 * @param props 
 * @returns 
 */
export function getProductJumpConfig(props: {
  info: ProductCard;
  internalFrom?: string;
  channelSource?: string;
  globalId?: string;
  entry?: string;
  ctExt?: any;
  pushCityId?: string;
}): JumpConfig {
  const {
    info,
    channelSource,
    globalId,
    entry,
    ctExt,
    pushCityId,
  } = props;

  const poiInfo = info?.poiInfo || {};
  const poiId = poiInfo?.poiId;
  const poiIdEncrypt = poiInfo?.poiIdEncrypt;
  const prePagePoiId = poiId || null;
  const prePagePoiIdEncrypt = poiIdEncrypt || "";

  // 额外渠道来源与globalid参数
  let _params: any = {};
  if (channelSource) {
    _params = {
      channelSource,
      globalId,
    };
  }
  if (entry) {
    _params.entry = entry;
  }
  if (ctExt) {
    _params.ctExt = encodeURIComponent(JSON.stringify(ctExt));
  }
  if (pushCityId) {
    _params.pushCityId = pushCityId;
  }

  // ST 环境圈圈 H5 白名单验证
  // _params = appendQuanquanSTParams(_params);

  const params: any = {
    did: info?.productId,
    poiId,
    poiIdEncrypt,
    scpSource: info?.scpSource,
    internalFrom: APP_KEY,
    prePagePoiId,
    prePagePoiIdEncrypt,
    preTime: +new Date(),
    // channelType 和 unpl 用于跟单
    channelType: 'WANG_MENG',
    // 仅团APP环境传递 unpl 参数，H5 可以从 cookie 中读取，小程序可以从 Storage 中读取
    unpl: getAppEnv().isMT ? getUnpl() || '' : '',
    ..._params,
  };

  const goodDetailUrl = getGoodDetailPath();
  const urlSearchParams = new URLSearchParams(params);
  const queryString = urlSearchParams.toString();
  const jumpLink = queryString ? `${goodDetailUrl}?${queryString}` : goodDetailUrl;

  return {
    jumpLink,
    jumpType: getJumpTypeEnum(),
    source: 'productCard',
  };
}
